import type { EntityAnnotationsMessage } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import type {
	StoreAssistant,
	StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { updateStoreAssistant } from './updateStoreAssistant';

export const appendEntityAnnotationBatch = ({
	chat,
	answerId,
	entityAnnotationBatch,
}: {
	chat: StoreChatItem[];
	answerId: string;
	entityAnnotationBatch: EntityAnnotationsMessage;
}): StoreChatItem[] =>
	updateStoreAssistant({
		chat,
		promptId: answerId,
		updateFunction: (storeAssistant): StoreAssistant => ({
			...storeAssistant,
			entityAnnotationBatches: [
				...(storeAssistant.entityAnnotationBatches ?? []),
				entityAnnotationBatch,
			],
		}),
		updateType: 'Append Entity Annotation Batch',
	});
